module.exports = __webpack_public_path__ + "static/media/ios-document.a692c491.svg";